(function (global) {
  'use strict';

  var PAYROLL_LIABILITY_CODE = '2930';
  var EMPLOYEE_EXPENSE_LIABILITY_CODE = '2911';
  var EMPLOYEE_LIABILITY_PREFIX = PAYROLL_LIABILITY_CODE + ':';
  var HOLIDAY_PAY_LIABILITY_CODE = '2941';
  var PAYROLL_CONTROL_CODES = { '2600': true, '2770': true, '2780': true, '2930': true };
  var amount = function (value) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };
  var change = function (account) {
    return account && account.endring != null
      ? amount(account.endring)
      : amount(account && account.ut) - amount(account && account.inn);
  };

  var matchesAccountSelection = function (accountCode, selection) {
    var code = String(accountCode || '').trim();
    var selectedCode = String(selection && (selection.nr || selection.accountCode) || '').trim();
    if (!selectedCode) return true;
    return code === selectedCode || !!(selection && selection.includeSubaccounts && code.indexOf(selectedCode + ':') === 0);
  };

  var filterPostingsForSelection = function (postings, selection, voucher) {
    var source = Array.isArray(postings) ? postings : [];
    if (!selection) return source;
    var voucherIds = Array.isArray(selection.voucherIds) ? selection.voucherIds.map(String) : [];
    if (voucherIds.length && (!voucher || voucherIds.indexOf(String(voucher.id || '')) < 0)) return [];
    return source.filter(function (posting) {
      if (!matchesAccountSelection(posting && (posting.nr || posting.accountCode), selection)) return false;
      if (selection.employeeId && String(posting && posting.employeeId || '') !== String(selection.employeeId)) return false;
      return true;
    });
  };

  var cloneFilter = function (filter) {
    if (!filter || typeof filter !== 'object') return null;
    return Object.assign({}, filter, {
      months: Array.isArray(filter.months) ? filter.months.slice() : filter.months,
      checks: Object.assign({}, filter.checks || {}),
    });
  };

  var rememberReportFilter = function (reportKey, filter) {
    if (!reportKey) return;
    global.__plummeReportReturnFilters = Object.assign({}, global.__plummeReportReturnFilters || {}, {
      [reportKey]: cloneFilter(filter),
    });
  };

  var consumeReportFilter = function (reportKey) {
    var filters = global.__plummeReportReturnFilters || {};
    var filter = cloneFilter(filters[reportKey]);
    if (!filter) return null;
    var remaining = Object.assign({}, filters);
    delete remaining[reportKey];
    global.__plummeReportReturnFilters = remaining;
    return filter;
  };

  // Lager bare en virtuell visningsrad. De faktiske kontoene beholdes urørt i
  // rapportmodellen, bilagsoppslaget og eksportene.
  var groupPayrollLiabilityAccounts = function (accounts) {
    var source = Array.isArray(accounts) ? accounts : [];
    var employees = source.filter(function (account) {
      return String(account && account.nr || '').indexOf(EMPLOYEE_LIABILITY_PREFIX) === 0;
    });
    if (!employees.length) return source.map(function (account) { return { kind: 'account', account: account }; });

    var baseAccounts = source.filter(function (account) {
      return String(account && account.nr || '') === PAYROLL_LIABILITY_CODE;
    });
    var grouped = baseAccounts.concat(employees);
    var groupedCodes = {};
    grouped.forEach(function (account) { groupedCodes[String(account.nr)] = true; });
    var parent = grouped.reduce(function (sum, account) {
      sum.inn += amount(account.inn);
      sum.endring += change(account);
      sum.ut += amount(account.ut);
      return sum;
    }, { nr: PAYROLL_LIABILITY_CODE, name: 'Skyldig lønn', inn: 0, endring: 0, ut: 0 });
    var firstGroupedIndex = source.findIndex(function (account) { return groupedCodes[String(account && account.nr || '')]; });
    var rows = [];
    source.forEach(function (account, index) {
      if (index === firstGroupedIndex) rows.push({
        kind: 'payroll-liability',
        account: parent,
        employeeAccounts: employees,
        otherAccounts: baseAccounts,
      });
      if (!groupedCodes[String(account && account.nr || '')]) rows.push({ kind: 'account', account: account });
    });
    return rows;
  };

  var voucherIsoDate = function (value) {
    var text = String(value || '');
    var match = text.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    return match ? match[3] + '-' + match[2] + '-' + match[1] : text.slice(0, 10);
  };
  var periodBounds = function (year, filter) {
    var months = Array.isArray(filter && filter.months) ? filter.months : [0, 11];
    var startMonth = Math.max(0, Math.min(11, Number(months[0]) || 0));
    var endMonth = Math.max(startMonth, Math.min(11, Number(months[1]) || 0));
    var lastDay = new Date(Number(year), endMonth + 1, 0).getDate();
    return {
      from: String(filter && filter.from || year + '-' + String(startMonth + 1).padStart(2, '0') + '-01'),
      to: String(filter && filter.to || year + '-' + String(endMonth + 1).padStart(2, '0') + '-' + String(lastDay).padStart(2, '0')),
    };
  };
  var accountForEntries = function (code, name, entries, bounds, selection) {
    var values = entries.reduce(function (sum, entry) {
      var signed = amount(entry.posting && entry.posting.amount);
      if (entry.date < bounds.from) sum.inn += signed;
      if (entry.date >= bounds.from && entry.date <= bounds.to) sum.endring += signed;
      if (entry.date <= bounds.to) sum.ut += signed;
      return sum;
    }, { inn: 0, endring: 0, ut: 0 });
    return Object.assign({ nr: code, name: name }, values, selection || {});
  };
  var unique = function (values) {
    var seen = {};
    return values.filter(function (value) {
      var key = String(value || '');
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };
  var genericAccountName = function (account) {
    var code = String(account && account.nr || '').trim();
    var name = String(account && account.name || '').trim();
    return !name || name === code || name.toLowerCase() === ('konto ' + code).toLowerCase();
  };
  var payrollAccountFields = function (familyCode) {
    return familyCode === EMPLOYEE_EXPENSE_LIABILITY_CODE
      ? ['expenseReimbursementLiabilityAccountCode']
      : familyCode === HOLIDAY_PAY_LIABILITY_CODE
        ? ['holidayPayLiabilityAccountCode']
        : ['netPayLiabilityAccountCode', 'payrollLiabilityAccountCode'];
  };
  var payrollEmployeeName = function (accountCode, familyCode, config) {
    var state = config && config.state || {};
    var employees = Array.isArray(state.employees) ? state.employees : [];
    var nameFor = function (line) {
      var direct = String(line && (line.employeeName || line.name) || '').trim();
      if (direct) return direct;
      var employeeId = String(line && (line.employeeId || line.id) || '').trim();
      var employee = employees.find(function (candidate) { return String(candidate && candidate.id || '') === employeeId; });
      return String(employee && employee.name || '').trim();
    };
    var fields = payrollAccountFields(familyCode);
    var lines = (Array.isArray(state.payrollRuns) ? state.payrollRuns : []).flatMap(function (run) { return Array.isArray(run && run.lines) ? run.lines : []; });
    var matchingLine = lines.find(function (line) {
      return fields.some(function (field) { return String(line && line[field] || '').trim() === accountCode; });
    });
    if (matchingLine) return nameFor(matchingLine);
    var matchingEmployee = employees.find(function (employee) {
      return fields.some(function (field) { return String(employee && employee[field] || '').trim() === accountCode; });
    });
    if (matchingEmployee) return nameFor(matchingEmployee);
    var vouchers = Array.isArray(config && config.vouchers) ? config.vouchers : [];
    for (var index = 0; index < vouchers.length; index += 1) {
      var postings = Array.isArray(vouchers[index] && vouchers[index].postings) ? vouchers[index].postings : [];
      var posting = postings.find(function (candidate) { return String(candidate && (candidate.nr || candidate.accountCode) || '').trim() === accountCode; });
      var postingName = String(posting && posting.employeeName || '').trim();
      if (postingName) return postingName;
    }
    return '';
  };
  var namePayrollSubaccount = function (account, familyCode, config, labels) {
    if (!genericAccountName(account)) return account;
    var employeeName = payrollEmployeeName(String(account && account.nr || ''), familyCode, config);
    return employeeName ? Object.assign({}, account, { name: labels.familyName(familyCode) + ' – ' + employeeName }) : account;
  };
  var employeeGroups = function (entries, code, bounds) {
    var groups = {};
    entries.forEach(function (entry) {
      var employeeId = String(entry.posting && entry.posting.employeeId || '');
      if (!employeeId) return;
      if (!groups[employeeId]) groups[employeeId] = [];
      groups[employeeId].push(entry);
    });
    return Object.keys(groups).map(function (employeeId) {
      var employeeEntries = groups[employeeId];
      var employeeName = employeeEntries[0].posting.employeeName || employeeId;
      return accountForEntries(code, employeeName, employeeEntries, bounds, {
        employeeId: employeeId,
        voucherIds: unique(employeeEntries.map(function (entry) { return entry.voucher.id; })),
      });
    });
  };
  var payrollControlGroups = function (code, vouchers, year, filter, labels) {
    var bounds = periodBounds(year, filter || {});
    var entries = [];
    (Array.isArray(vouchers) ? vouchers : []).forEach(function (voucher) {
      var date = voucherIsoDate(voucher && voucher.date);
      (Array.isArray(voucher && voucher.postings) ? voucher.postings : []).forEach(function (posting) {
        if (String(posting && (posting.nr || posting.accountCode) || '') === code) entries.push({ voucher: voucher, posting: posting, date: date });
      });
    });
    var topGroups = {};
    entries.forEach(function (entry) {
      var voucher = entry.voucher || {};
      var posting = entry.posting || {};
      var key;
      var label;
      if (code === '2600' || code === PAYROLL_LIABILITY_CODE) {
        key = String(voucher.payrollRunId || voucher.sourceId || voucher.id || 'other');
        label = labels.payrollRun(voucher.payrollPeriod || posting.payrollPeriod || '', voucher.num || '');
      } else if (code === '2770') {
        var term = Number(voucher.payrollTerm || Math.ceil(Number(entry.date.slice(5, 7) || 1) / 2));
        key = String(voucher.reportingYear || entry.date.slice(0, 4)) + '-' + term;
        label = labels.term(term, voucher.reportingYear || entry.date.slice(0, 4));
      } else {
        var accrualYear = Number(posting.accrualYear || voucher.reportingYear || entry.date.slice(0, 4));
        key = String(accrualYear || year);
        label = labels.accrualYear(accrualYear || year);
      }
      if (!topGroups[key]) topGroups[key] = { label: label, entries: [] };
      topGroups[key].entries.push(entry);
    });
    return Object.keys(topGroups).sort().map(function (key) {
      var group = topGroups[key];
      var voucherIds = unique(group.entries.map(function (entry) { return entry.voucher.id; }));
      var childAccounts = code === '2770'
        ? (function () {
          var runs = {};
          group.entries.forEach(function (entry) {
            var voucher = entry.voucher || {};
            var runKey = String(voucher.payrollRunId || voucher.payrollPeriod || voucher.id || 'other');
            if (!runs[runKey]) runs[runKey] = [];
            runs[runKey].push(entry);
          });
          return Object.keys(runs).map(function (runKey) {
            var runEntries = runs[runKey];
            var voucher = runEntries[0].voucher || {};
            return accountForEntries(code, labels.payrollRun(voucher.payrollPeriod || '', voucher.num || ''), runEntries, bounds, {
              voucherIds: unique(runEntries.map(function (entry) { return entry.voucher.id; })),
            });
          });
        })()
        : employeeGroups(group.entries, code, bounds);
      return accountForEntries(code, group.label, group.entries, bounds, { voucherIds: voucherIds, children: childAccounts });
    });
  };
  var groupAccountFamily = function (source, code, labels, config) {
    var prefix = code + ':';
    var subaccounts = source.filter(function (account) { return String(account && account.nr || '').indexOf(prefix) === 0; })
      .map(function (account) { return namePayrollSubaccount(account, code, config, labels); });
    if (!subaccounts.length) return null;
    var baseAccounts = source.filter(function (account) { return String(account && account.nr || '') === code; });
    var grouped = baseAccounts.concat(subaccounts);
    var parent = grouped.reduce(function (sum, account) {
      sum.inn += amount(account.inn);
      sum.endring += change(account);
      sum.ut += amount(account.ut);
      return sum;
    }, { nr: code, name: labels.familyName(code), inn: 0, endring: 0, ut: 0 });
    return { kind: 'payroll-family', key: 'family-' + code, account: parent, childAccounts: subaccounts, baseAccounts: baseAccounts };
  };
  var buildPayrollBalanceRows = function (accounts, options) {
    var source = Array.isArray(accounts) ? accounts : [];
    var config = options || {};
    if (String(config.country || '').toUpperCase() !== 'NO') return source.map(function (account) { return { kind: 'account', account: account }; });
    var labels = Object.assign({
      familyName: function (code) { return code === EMPLOYEE_EXPENSE_LIABILITY_CODE ? 'Skyldige utlegg til ansatte' : code === HOLIDAY_PAY_LIABILITY_CODE ? 'Skyldige feriepenger' : 'Skyldig l\u00f8nn'; },
      payrollRun: function (period, number) { return period ? 'L\u00f8nnskj\u00f8ring ' + period : 'L\u00f8nnskj\u00f8ring ' + number; },
      term: function (term, reportingYear) { return term + '. termin ' + reportingYear; },
      accrualYear: function (accrualYear) { return 'Opptjenings\u00e5r ' + accrualYear; },
    }, config.labels || {});
    var families = {};
    [EMPLOYEE_EXPENSE_LIABILITY_CODE, PAYROLL_LIABILITY_CODE, HOLIDAY_PAY_LIABILITY_CODE].forEach(function (code) {
      var family = groupAccountFamily(source, code, labels, config);
      if (family) families[code] = family;
    });
    var inserted = {};
    var rows = [];
    source.forEach(function (account) {
      var code = String(account && account.nr || '');
      var familyCode = [EMPLOYEE_EXPENSE_LIABILITY_CODE, PAYROLL_LIABILITY_CODE, HOLIDAY_PAY_LIABILITY_CODE].find(function (candidate) { return code === candidate || code.indexOf(candidate + ':') === 0; });
      if (familyCode && families[familyCode]) {
        if (!inserted[familyCode]) rows.push(families[familyCode]);
        inserted[familyCode] = true;
        return;
      }
      if (PAYROLL_CONTROL_CODES[code]) {
        rows.push({
          kind: 'payroll-control',
          key: 'control-' + code,
          account: account,
          childAccounts: payrollControlGroups(code, config.vouchers, config.year, config.filter, labels),
        });
        return;
      }
      rows.push({ kind: 'account', account: account });
    });
    return rows;
  };

  global.PlummeTrialBalancePresentation = {
    groupPayrollLiabilityAccounts: groupPayrollLiabilityAccounts,
    buildPayrollBalanceRows: buildPayrollBalanceRows,
    matchesAccountSelection: matchesAccountSelection,
    filterPostingsForSelection: filterPostingsForSelection,
    rememberReportFilter: rememberReportFilter,
    consumeReportFilter: consumeReportFilter,
  };
})(window);
